export class SchemaRegistryResolveSubjectResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resolutions",
            "baseName": "resolutions",
            "type": "Array<SubjectResolution>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SchemaRegistryResolveSubjectResponse.attributeTypeMap;
    }
    constructor() {
    }
}
